import { render, staticRenderFns } from "./TurnoverMobile.vue?vue&type=template&id=4c410e54&scoped=true&"
import script from "./TurnoverMobile.vue?vue&type=script&lang=js&"
export * from "./TurnoverMobile.vue?vue&type=script&lang=js&"
import style0 from "./TurnoverMobile.vue?vue&type=style&index=0&id=4c410e54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c410e54",
  null
  
)

export default component.exports